import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  InputAdornment,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";

import SideBar from "../Component/SideBar";
import useUncategorizedGroupedApi from "../Api/useUncategorizedGroupedApi";

const UncategorizedGrouped = () => {
  const navigate = useNavigate();

  const { getUncategorizedGrouped, groups, loading, totalPages } =
    useUncategorizedGroupedApi();

  const [pageNum, setPageNum] = useState(1);
  const pageSize = 5;

  const [mainSearch, setMainSearch] = useState("");

  useEffect(() => {
    document.title = "";
    getUncategorizedGrouped({
      pageNum,
      pageSize,
      isProcessed: false,
    });
  }, [pageNum]);

  // ---------------------- MAIN DOMAIN SEARCH FILTER ----------------------
  const mainFilteredGroups = groups.filter((row) => {
    const search = mainSearch.toLowerCase();
    return (
      row.domain.toLowerCase().includes(search) ||
      String(row.count).includes(search) ||
      row.entries.some((e) => e.url.toLowerCase().includes(search))
    );
  });

  // --------- HANDLE EXPAND → OPEN NEW PAGE ----------
  const openDetailsPage = (item) => {
    navigate("/SetCategory", { state: { domain: item.domain } });
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <SideBar />

      <Box component="main" className="main-box">
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Uncategorized URL
        </Typography>

        <Paper
          sx={{
            borderRadius: 3,
            p: 3,
            boxShadow: "0px 12px 30px rgba(0,0,0,0.1)",
          }}
        >
          <Typography variant="h6" fontWeight={600} mb={2}>
            Domains (Grouped)
          </Typography>

          {/* ---------------- MAIN SEARCH ---------------- */}
          <TextField
            fullWidth
            size="small"
            placeholder="Search domains, count or URLs..."
            value={mainSearch}
            onChange={(e) => setMainSearch(e.target.value)}
            sx={{ mb: 3 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* ---------------- LOADING ---------------- */}
          {loading && (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <CircularProgress />
              <Typography mt={1} color="text.secondary">
                Loading grouped data…
              </Typography>
            </Box>
          )}

          {/* ---------------- TABLE ---------------- */}
          {!loading && mainFilteredGroups.length > 0 && (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ background: "#f4f4f4" }}>
                    <TableCell sx={{ fontWeight: "bold" }}>Domain</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Count</TableCell>
                    <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                      Expand
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {mainFilteredGroups.map((item, idx) => (
                    <TableRow key={idx} hover>
                      <TableCell>
                        <Typography fontWeight={600}>{item.domain}</Typography>
                      </TableCell>

                      <TableCell>
                        <Typography fontWeight={700}>{item.count}</Typography>
                      </TableCell>

                      <TableCell align="center">
                        <IconButton onClick={() => openDetailsPage(item)}>
                          <ExpandMoreIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* ---------------- MAIN EMPTY ---------------- */}
          {!loading && mainFilteredGroups.length === 0 && (
            <Typography
              sx={{ textAlign: "center", py: 3 }}
              color="text.secondary"
            >
              No domains found.
            </Typography>
          )}

          {/* ---------------- MAIN PAGINATION ---------------- */}
          {!loading && groups.length > 0 && (
            <TablePagination
              component="div"
              count={totalPages * pageSize}
              page={pageNum - 1}
              rowsPerPage={pageSize}
              rowsPerPageOptions={[pageSize]}
              onPageChange={(e, newPage) => setPageNum(newPage + 1)}
            />
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default UncategorizedGrouped;
